import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { BrowseLayoutContext } from "#browse-layout-context";

/**
 * Returns the `setParentBrowseTab` setter from `BrowseLayoutContext`. Called by the browse sub-tab
 * layout on tab change (with the focused tab's title) and by the search-card detail layout on focus
 * (with "Search"), so `<BrowseNavBackButton>` can label the back control with wherever the user came
 * from. Subscribes only to the setter, which is referentially stable, so writers never re-render on
 * `parentBrowseTab` changes.
 */
export function useSetParentBrowseTab() {
  const [setParentBrowseTab] = useContextSelectors(
    BrowseLayoutContext,
    (c) => c.setParentBrowseTab,
  );
  return setParentBrowseTab;
}
